import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <section className="main" />;
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

Home.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./source/client/containers/home/index.jsx